module.exports = __webpack_public_path__ + "img/program-img_1.d5c67a9e.png";